export default "<div class=\"banner\">\n  <img [src]=\"getRandomImg()\">\n</div>"